import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const AKIT_LOGO = "https://customer-assets.emergentagent.com/job_dev-auth-platform/artifacts/3yr5z3x8_AKIT%20LOGO%202%281%29.png";

  return (
    <footer className="border-t border-white/5 bg-black/30 mt-auto">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={AKIT_LOGO} 
                alt="AKIT Logo" 
                className="h-14 w-14 rounded-lg object-contain"
              />
              <div>
                <h3 className="font-heading font-bold text-foreground">AKIT Kenya</h3>
                <p className="text-xs text-muted-foreground">Association of Kenya IRE Teachers</p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
              Empowering Islamic Religious Education teachers across Kenya through professional development, 
              resource sharing, and collective advocacy for educational excellence.
            </p>
            <p className="text-primary font-amiri text-lg mt-4">السَّلَامُ عَلَيْكُمْ وَرَحْمَةُ اللهِ</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/resources" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/vacancies" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Job Vacancies
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Join AKIT
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Mail className="h-4 w-4 text-primary" />
                info.akit001@gmail.com
              </li>
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Phone className="h-4 w-4 text-primary" />
                +254 707 610 099 or +254 710 215 839
              </li>
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4 text-primary" />
                Nairobi, Kenya
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-8 pt-8 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Association of Kenya IRE Teachers. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
